import AntTabs from "antd/es/tabs";
import styled from "styled-components";
import { MOBILE_CREATE_TRADE } from "common/constants";

const Tabs = styled(AntTabs)<{ $hideBorder?: boolean; $isSmall?: boolean }>`
  .ant-tabs-ink-bar {
    background: ${(p) => p.theme.colors.primaryBlue};
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(p) => p.theme.colors.primaryBlue}!important;
  }

  .ant-tabs-tab-btn {
    color: ${(p) => p.theme.colors.textColor};

    @media (min-width: ${MOBILE_CREATE_TRADE}) {
      &:hover {
        color: ${(p) => p.theme.colors.primaryBlue};
      }
    }
  }
  .ant-tabs-nav {
    &::before {
      border-color: ${(p) => p.theme.colors.lightestBorderGrey};
      ${(p) =>
        p.$hideBorder &&
        `
        border: none;
      `}
    }
  }
  .ant-tabs-nav-operations {
    display: none !important;
  }
  ${(p) =>
    p.$isSmall &&
    `
      .ant-tabs-tab {
        font-size: ${p.theme.typography.fontSizes.S};
      }
      .ant-tabs-tab + .ant-tabs-tab {
        margin: 0 0 0 20px;
      }
  `}
`;

export default Tabs;
